/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useContext, useEffect, useRef } from "react";
import Loader from "../../assets/images/loader.gif";
import LoaderEN from "../../assets/images/circular.gif";
import LoaderSM from "../../assets/images/loaderSM.gif";
import { MenuItem } from "@material-ui/core";
import styled from "styled-components";
import Input from "./Input";
import AppContext from "../../context/store";

const AutocompleteInput = (props) => {
  const context = useContext(AppContext);
  const optionsContainerRef = useRef(null);

  // Suggested menu show/hide
  const [open, setOpen] = useState(false);

  // Input end-adornment loader
  const [loading, setLoading] = useState(false);

  // Loading more data on scroll
  const [loadingMore, setLoadingMore] = useState(false);

  // Suggested values
  const [options, setOptions] = useState();

  // Posting to async request
  const [keyword, setKeyword] = useState("");

  // Handling this
  const [selected, setSelected] = useState(
    props.selected ? props.selected : null
  );

  // Input value
  const [input, setInput] = useState(null);

  useEffect(() => {
    if (
      keyword !== null &&
      keyword !== "" &&
      (selected && selected.hasOwnProperty(props.labelKey)
        ? selected[props.labelKey] !== keyword
          ? true
          : false
        : true)
    ) {
      (async () => {
        const x = await props.asyncDataService(keyword);
        setOptions(Array.isArray(x) && x.length ? [...x] : []);
        setLoading(false);
        setOpen(true);
      })();
    } else {
      setLoading(false);
      setOpen(false);
    }
  }, [keyword]);

  useEffect(() => {
    selected
      ? props.selectedHandler(
        props.returnFullObject ? selected : selected[props.valueKey]
      )
      : setKeyword("");
  }, [selected]);

  useEffect(() => {
    setSelected(props.selected);
  }, [props.selected]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (optionsContainerRef.current && !optionsContainerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const handleScroll = async (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const isNearBottom = scrollTop + clientHeight >= scrollHeight - 50;

    console.log('Scroll event:', { scrollTop, scrollHeight, clientHeight, isNearBottom, loadingMore });

    if (isNearBottom && !loadingMore && props.onScrollBottom) {
      console.log('Loading more data...');
      setLoadingMore(true);
      const newData = await props.onScrollBottom(keyword);
      if (newData && newData.length > 0) {
        setOptions(prev => [...(prev || []), ...newData]);
      }
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    if (input !== null && input !== keyword) {
      const handler = setTimeout(() => {
        setKeyword(input);
        setLoading(true);
      }, 800);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [input]);

  return (
    <AutocompleteContainer className="mb-3">
      <Input
        required={props.required}
        style={props.style}
        onClick={async (e) => {
          e.stopPropagation();
          if (props.disabled || selected) return;

          setLoading(true);
          setOpen(true);

          const searchKey = keyword && keyword.trim() !== "" ? keyword : " ";
          try {
            const x = await props.asyncDataService(searchKey);
            setOptions(Array.isArray(x) && x.length ? [...x] : []);
          } catch (_) {
            setOptions([]);
          } finally {
            setLoading(false);
          }

          // keyword zaten " " ise setState tetikleme; aksi halde useEffect tekrar fetch eder
          if (keyword !== searchKey) {
            setKeyword(searchKey);
          }
        }}
        className="mb-0"
        readOnly={selected ? true : false}
        label={props.label}
        helperText={props.helperText}
        disabled={props.disabled}
        hoverHelperText={props.hoverHelperText}
        placeholder={props.placeholder}
        value={`${selected?.[props.labelKey] ?? input ?? props.value ?? ""}`}
        InputProps={{
          onChange: (e) => {
            setInput(e.target.value);
          },
          startAdornment: props.startAdornment ? props.startAdornment : "",
          endAdornment: (
            <React.Fragment>
              {selected || props.value ? (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={async () => {
                    await setKeyword("");
                    await setInput("");
                    await setSelected(null);
                    await props.onRemove();
                  }}
                  className="material-icons"
                >
                  close
                </span>
              ) : loading ? (
                <img
                  src={
                    process.env.APP_NAME === "salon"
                      ? Loader
                      : process.env.APP_NAME === "en"
                        ? LoaderEN
                        : LoaderSM
                  }
                  width="50"
                  height="50"
                  alt="loading"
                />
              ) : null}
            </React.Fragment>
          ),
        }}
      />
      {open && !props.disabled ? (
        <OptionsContainerWrapper
          hasHelperText={props.helperText !== undefined ? true : false}
          style={props.opcStyle}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div
            ref={optionsContainerRef}
            onScroll={handleScroll}
            style={{
              height: 'auto',
              maxHeight: '35vh',
              overflowY: 'auto',
              overflowX: 'hidden',
              WebkitOverflowScrolling: 'touch',
              padding: '0',
              cursor: 'default'
            }}
          >
            {options &&
              options.length > 0 &&
              options.map((option, index) => (
                <div
                  key={index}
                  onClick={async () => {
                    setSelected(option);
                    setOpen(false);
                    setKeyword(option[props.labelKey]);
                  }}
                  style={{
                    padding: '10px 16px',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    backgroundColor: 'transparent',
                    minHeight: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #f0f0f0'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.extraLimit ? (
                      <p style={{ margin: 0 }}>{`${option[props.labelKey]} (${option[props.extraLimit]
                        })`}</p>
                    ) : (
                      <p style={{ margin: 0 }}>{option[props.labelKey]}</p>
                    )}
                    <p style={{ margin: 0 }}>
                      {props.showField
                        ? `${Math.round(option[props.showField])} ${context.state.currency ? context.state.currency : "₺"
                        }`
                        : ""}
                    </p>
                  </div>
                </div>
              ))}
            {loadingMore && (
              <div style={{ textAlign: 'center', padding: '10px' }}>
                <img
                  src={
                    process.env.APP_NAME === "salon"
                      ? Loader
                      : process.env.APP_NAME === "en"
                        ? LoaderEN
                        : LoaderSM
                  }
                  width="30"
                  height="30"
                  alt="loading more"
                />
              </div>
            )}
          </div>
        </OptionsContainerWrapper>
      ) : null}
    </AutocompleteContainer>
  );
};

export default React.memo(AutocompleteInput);

const AutocompleteContainer = styled.div`
  position: relative;
  width: 100%;
`;

const OptionsContainerWrapper = styled.div`
  width: 100%;
  background: #fff;
  margin-top: ${({ hasHelperText }) =>
    `${hasHelperText === true ? "-22px" : "0"}`};
  border-radius: 5px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
  z-index: 999999 !important;
  position: absolute;
  padding: 8px 0;
`;
